document.addEventListener('DOMContentLoaded', () => {
    const freightBars = document.querySelectorAll('.purple-freight-bar');
    const freightBarsCart = document.querySelectorAll('.freebar');

    if (freightBars.length === 0) return;

    const formatMoney = (cents) => {
        return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    let lastStickyHeight = null;
    const updateHeight = () => {
        requestAnimationFrame(() => {
            let stickyHeight = 0;
            // Read phase
            freightBars.forEach(bar => {
                if (bar.dataset.sticky === 'true') {
                    stickyHeight = bar.offsetHeight;
                }
            });
            // Write phase (only if changed to avoid layout thrashing/forced reflow)
            if (stickyHeight !== lastStickyHeight) {
                document.documentElement.style.setProperty('--freight-bar-height', `${stickyHeight}px`);
                lastStickyHeight = stickyHeight;
            }
        });
    };

    const updateFreightBar = (totalPrice) => {
        freightBars.forEach(bar => {
            const limit = parseInt(bar.dataset.limit, 10);
            const msgStarted = bar.dataset.msgStarted;
            const msgProgress = bar.dataset.msgProgress;

            const limitMoney = formatMoney(limit);
            const remainingMoney = formatMoney(limit - totalPrice);

            const startedEl = bar.querySelector('.freight-message_started');
            const progressEl = bar.querySelector('.freight-message_progress');
            const successEl = bar.querySelector('.freight-message_success');

            if (!startedEl || !progressEl || !successEl) return;

            if (totalPrice === 0) {
                startedEl.innerHTML = msgStarted.replace('[limit]', limitMoney);
                startedEl.removeAttribute('hidden');
                progressEl.setAttribute('hidden', '');
                successEl.setAttribute('hidden', '');
            }
            else if (totalPrice < limit) {
                progressEl.innerHTML = msgProgress
                    .replace('[remaining]', remainingMoney)
                    .replace('[limit]', limitMoney);

                progressEl.removeAttribute('hidden');
                startedEl.setAttribute('hidden', '');
                successEl.setAttribute('hidden', '');
            } else {
                successEl.removeAttribute('hidden');
                startedEl.setAttribute('hidden', '');
                progressEl.setAttribute('hidden', '');
            }

            const progressIEl = bar.querySelector('.track i');
            if (progressIEl && limit > 0) {
                let percent = (totalPrice / limit) * 100;
                if (percent > 100) percent = 100;
                progressIEl.style.width = `${percent}%`;
            }
        });

        if (freightBarsCart.length > 0) {
            freightBarsCart.forEach(bar => {
                const limit = parseInt(bar.dataset.limit, 10);
                const msgStarted = bar.dataset.msgStarted;
                const msgProgress = bar.dataset.msgProgress;

                const limitMoney = formatMoney(limit);
                const remainingMoney = formatMoney(limit - totalPrice);

                const startedEl = bar.querySelector('.freight-message_started');
                const progressEl = bar.querySelector('.freight-message_progress');
                const successEl = bar.querySelector('.freight-message_success');

                if (!startedEl || !progressEl || !successEl) return;

                if (totalPrice === 0) {
                    startedEl.innerHTML = msgStarted.replace('[limit]', limitMoney);
                    startedEl.removeAttribute('hidden');
                    progressEl.setAttribute('hidden', '');
                    successEl.setAttribute('hidden', '');
                }
                else if (totalPrice < limit) {
                    progressEl.innerHTML = msgProgress
                        .replace('[remaining]', remainingMoney)
                        .replace('[limit]', limitMoney);

                    progressEl.removeAttribute('hidden');
                    startedEl.setAttribute('hidden', '');
                    successEl.setAttribute('hidden', '');
                } else {
                    successEl.removeAttribute('hidden');
                    startedEl.setAttribute('hidden', '');
                    progressEl.setAttribute('hidden', '');
                }

                const progressIEl = bar.querySelector('.track i');
                if (progressIEl && limit > 0) {
                    let percent = (totalPrice / limit) * 100;
                    if (percent > 100) percent = 100;
                    progressIEl.style.width = `${percent}%`;
                }
            });
        }

        updateHeight();
    };

    const debounce = (fn, wait = 250) => {
        let timeout;
        return function (...args) {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, args), wait);
        };
    };

    updateHeight();
    window.addEventListener('resize', debounce(updateHeight, 250));

    document.addEventListener('cart:updated', (e) => {
        if (e.detail && e.detail.cart && e.detail.cart.total_price !== undefined) {
            updateFreightBar(e.detail.cart.total_price);
        } else {
            fetch('/cart.js').then(res => res.json()).then(cart => {
                updateFreightBar(cart.total_price);
            });
        }
    });
});